// @ts-expect-error pure js
import { SignatureStatus } from "../../models/signatureElectronique";
import { IconCheck, IconX } from "@tabler/icons-react";

interface SignatureStatusMarkProps {
  status?: number | string | null;
}

export default function SignatureStatusMark({
  status,
}: SignatureStatusMarkProps) {
  if (status === SignatureStatus.Signed.status) {
    return <IconCheck size={20} color="lightgreen" />;
  }
  return <IconX size={20} color="red" />;
}
